/**
 * Full text of the Dhansthal Business Associate / DSA Empanelment Agreement.
 * Source of truth PDF: /dsa-empanelment-agreement.pdf (Version 1.0)
 * Content extracted from the official agreement PDF — do not invent or summarize.
 */
import React from 'react';

export const DSA_EMPANELMENT_AGREEMENT_PDF_URL = '/dsa-empanelment-agreement.pdf';
export const DSA_EMPANELMENT_AGREEMENT_VERSION = '1.0';
export const DSA_EMPANELMENT_AGREEMENT_TYPE = 'dsa_empanelment';

const sectionTitle = { fontSize: '17px', fontWeight: '700', margin: '22px 0 10px', color: '#111' };
const body = { margin: '0 0 12px', textAlign: 'justify' };
const sub = { margin: '0 0 8px', textAlign: 'justify' };

export default function DsaEmpanelmentAgreementContent() {
  return (
    <div style={{ padding: '36px 24px', fontFamily: 'Georgia, serif', color: '#1a1a1a', lineHeight: '1.75', fontSize: '15px' }}>
      <div style={{ textAlign: 'center', marginBottom: '28px' }}>
        <p style={{ fontSize: '13px', letterSpacing: '2px', fontWeight: 700, marginBottom: 4 }}>DHANSTHAL</p>
        <p style={{ fontSize: '12px', color: '#888', marginBottom: 16 }}>Powered by Kadellabs</p>
        <h1 style={{ fontSize: '22px', fontWeight: '700', letterSpacing: '0.5px', marginBottom: '6px' }}>
          BUSINESS ASSOCIATE / DSA EMPANELMENT AGREEMENT
        </h1>
        <p style={{ fontSize: '12px', color: '#888' }}>Version {DSA_EMPANELMENT_AGREEMENT_VERSION}</p>
      </div>

      <p style={body}>
        This Business Associate Agreement (&quot;Agreement&quot;) is entered into on this _____ day of ______________, 20___
        (&quot;Effective Date&quot;), by and between:
      </p>
      <p style={body}>
        <strong>DHANSTHAL</strong>, a loan sourcing and distribution platform powered by Kadellabs, having its registered office at 3 Floor,
        T2313 - Tower 2, Ardente Office One, Hoodi Main Road, Hoodi Locality, Bengaluru, Karnataka, - 560048
        (hereinafter referred to as the &quot;Company&quot; or &quot;Dhansthal&quot;, which expression shall, unless repugnant to the context,
        include its successors and permitted assigns) of the FIRST PART;
      </p>
      <p style={{ textAlign: 'center', margin: '12px 0', fontWeight: 600 }}>AND</p>
      <p style={body}>
        _____________________________________ [Name of Loan Connector / DSA / Firm], a [proprietorship /
        partnership firm / company] having its registered/business address at
        _____________________________________________________, PAN: ______________ ______________, GSTIN:
        ______________ (hereinafter referred to as the &quot;Associate&quot; or &quot;Connector&quot;, which expression shall, unless
        repugnant to the context, include its successors and permitted assigns) of the SECOND PART.
      </p>
      <p style={body}>
        The Company and the Associate are hereinafter individually referred to as a &quot;Party&quot; and collectively as the &quot;Parties&quot;.
      </p>

      <h2 style={sectionTitle}>RECITALS</h2>
      <p style={body}>
        WHEREAS Dhansthal is engaged in the business of loan sourcing, referral and facilitation services, and operates as
        a Corporate DSA (Direct Selling Agent) working with various banks, non-banking financial companies (NBFCs) and
        other regulated lending institutions (&quot;Lending Partners&quot;)
      </p>
      <p style={body}>
        WHEREAS the Associate is engaged in the business of sourcing and referring prospective loan applicants and has
        represented that it possesses the necessary infrastructure, manpower and market reach to source loan
        applications;
      </p>
      <p style={body}>
        WHEREAS the Associate desires to be empanelled with Dhansthal as a Business Associate / Loan Connector to
        source and refer loan leads/applications, and Dhansthal is willing to empanel the Associate on a non-exclusive basis,
        subject to the terms and conditions set out herein;
      </p>
      <p style={body}>
        NOW THEREFORE, in consideration of the mutual covenants and agreements contained herein, the Parties agree
        as follows:
      </p>

      <h2 style={sectionTitle}>1. Definitions</h2>
      <p style={sub}>1.1 &quot;Lead&quot; means any prospective customer referred by the Associate to Dhansthal for a loan or financial product.</p>
      <p style={sub}>1.2 &quot;Lending Partner&quot; means any bank, NBFC or financial institution with which Dhansthal has a sourcing/DSA arrangement.</p>
      <p style={sub}>1.3 &quot;Disbursed Loan&quot; means a loan sanctioned and disbursed by a Lending Partner pursuant to a Lead sourced by the Associate.</p>
      <p style={sub}>1.4 &quot;Payout&quot; means the commission/referral fee payable to the Associate as per Annexure B.</p>

      <h2 style={sectionTitle}>2. Appointment and Scope</h2>
      <p style={sub}>
        2.1 Dhansthal hereby appoints the Associate, and the Associate hereby accepts the appointment, as a non-exclusive
        Business Associate/Loan Connector for the purpose of sourcing and referring Leads for Home loans, Loan Against
        Property, Personal loans, business loans (MSME – SME), Education Loan, Reverse Mortgage, and/or such other loan
        products as may be mutually agreed in writing from time to time.
      </p>
      <p style={sub}>
        2.2 The Associate shall only refer Leads and shall not hold itself out as an agent, employee or representative of
        Dhansthal or any Lending Partner and shall not have any authority to negotiate, sanction, disburse, collect
        repayments, or bind Dhansthal or any Lending Partner in any manner.
      </p>
      <p style={sub}>
        2.3 This appointment does not create any exclusivity in favor of either Party and both Parties are free to enter into
        similar arrangements with third parties, unless otherwise agreed in writing.
      </p>

      <h2 style={sectionTitle}>3. Term and Termination</h2>
      <p style={sub}>
        3.1 This Agreement shall commence on the Effective Date and remain valid for a period of one (1) year, unless
        terminated earlier in accordance with this Clause and shall thereafter automatically renew for successive one-year
        terms unless either Party gives notice of non-renewal.
      </p>
      <p style={sub}>
        3.2 Either Party may terminate this Agreement by giving thirty (30) days&apos; prior written notice to the other Party,
        without assigning any reason.
      </p>
      <p style={sub}>3.3 Dhansthal may terminate this Agreement with immediate effect, without notice, in the event of:</p>
      <p style={sub}>(a) any act of fraud, misrepresentation, or mis-selling by the Associate;</p>
      <p style={sub}>(b) breach of any regulatory or KYC requirement;</p>
      <p style={sub}>(c) any action that damages the reputation of Dhansthal or its Lending Partners; or</p>
      <p style={sub}>(d) a material breach of this Agreement that remains uncured for seven (7) days after written notice.</p>
      <p style={sub}>
        3.4 Termination shall not affect payouts already accrued and due for Disbursed Loans prior to the effective date of
        termination, subject to Clause 5.
      </p>

      <h2 style={sectionTitle}>4. Obligations of the Associate</h2>
      <p style={body}>
        The Associate shall: (a) conduct its sourcing activities in an honest, transparent and ethical manner and in
        compliance with applicable RBI / NHB / SEBI / IRDAI guidelines and any Fair Practices Code applicable to Dhansthal
        or its Lending Partners; (b) not make any false, misleading or exaggerated representations to prospective customers
        regarding interest rates, processing fees, loan eligibility, or approval timelines; (c) not charge any fee, commission
        or consideration directly or indirectly from prospective customers for sourcing or referring a Lead; (d) maintain
        confidentiality of all customer and business information; (e) promptly furnish complete and accurate KYC and
        supporting documentation for each Lead; (f) not engage in any activity that could be construed as poaching,
        coercion, or unfair solicitation; and (g) comply with all applicable data protection and privacy laws, including the
        Digital Personal Data Protection Act, 2023, while handling customer information.
      </p>

      <h2 style={sectionTitle}>5. Payout / Commission</h2>
      <p style={sub}>
        5.1 Dhansthal shall pay the Associate a Payout as set out in Annexure B, calculated as a percentage of the disbursed
        loan amount, subject to deduction of applicable TDS and taxes.
      </p>
      <p style={sub}>
        5.2 Payout shall accrue only upon actual disbursement of the loan by the Lending Partner and receipt of the
        corresponding payout/commission by Dhansthal from the Lending Partner, and shall be subject to clawback if the loan
        is foreclosed, cancelled or found to be fraudulently sourced within the period specified in Annexure B.
      </p>
      <p style={sub}>
        5.3 Payouts shall be processed within [30 - 60] days from the end of the month in which the underlying commission is
        received by Dhansthal from the Lending Partner, subject to the Associate raising a valid invoice/statement and
        completing applicable tax compliance (PAN, GST registration where applicable).
      </p>

      <h2 style={sectionTitle}>6. Representations and Warranties</h2>
      <p style={body}>
        The Associate represents and warrants that: (a) it has full right, power and authority to enter into this Agreement;
        (b) it holds all licenses, registrations and approvals required to carry on its business, if any are applicable to its
        activities; (c) all information and documents furnished for empanelment (Annexure A) are true, complete and
        accurate; and (d) it shall not sub-contract, assign or delegate its obligations under this Agreement to any third party
        without the Company&apos;s prior written consent.
      </p>

      <h2 style={sectionTitle}>7. Confidentiality</h2>
      <p style={body}>
        Each Party shall keep confidential all business, financial, customer and technical information disclosed by the other
        Party in connection with this Agreement, and shall not disclose such information to any third party except as
        required by law or with the prior written consent of the disclosing Party. This obligation shall survive termination
        of this Agreement for a period of two (2) years.
      </p>

      <h2 style={sectionTitle}>8. Indemnity</h2>
      <p style={body}>
        The Associate shall indemnify and keep indemnified Dhansthal and its Lending Partners against any loss, damage,
        claim, penalty or liability arising out of any misrepresentation, mis-selling, breach of KYC/regulatory norms, or
        negligent or wrongful act or omission of the Associate or its employees/representatives.
      </p>

      <h2 style={sectionTitle}>9. Independent Contractor Status</h2>
      <p style={body}>
        Nothing in this Agreement shall be construed as creating an employer-employee relationship, partnership, joint
        venture or agency relationship (other than a limited referral arrangement) between the Parties. The Associate shall
        be solely responsible for its own employees, taxes, statutory dues and compliances.
      </p>

      <h2 style={sectionTitle}>10. Compliance and Code of Conduct</h2>
      <p style={body}>
        The Associate agrees to abide by Dhansthal&apos;s Code of Conduct and Fair Practices policy (as may be updated from
        time to time and communicated to the Associate), and any Lending Partner-specific guidelines communicated to it
        for sourcing of that Lending Partner&apos;s products.
      </p>

      <h2 style={sectionTitle}>11. Dispute Resolution and Governing Law</h2>
      <p style={body}>
        This Agreement shall be governed by the laws of India. Any dispute arising out of or in connection with this
        Agreement shall first be attempted to be resolved amicably, failing which it shall be referred to arbitration under
        the Arbitration and Conciliation Act, 1996, by a sole arbitrator appointed mutually by the Parties, with the seat and
        venue of arbitration at _ Bangelore _. The courts at ___ Bangelore _ shall have exclusive jurisdiction.
      </p>

      <h2 style={sectionTitle}>12. Notices</h2>
      <p style={body}>
        All notices under this Agreement shall be in writing and sent by email (with acknowledgement) or registered
        post/courier to the addresses of the Parties mentioned above, or such other address as may be notified in writing.
      </p>

      <h2 style={sectionTitle}>13. Miscellaneous</h2>
      <p style={sub}>
        13.1 This Agreement, together with its Annexures, constitutes the entire agreement between the Parties and
        supersedes all prior discussions or understandings.
      </p>
      <p style={sub}>
        13.2 No amendment to this Agreement shall be valid unless made in writing and signed by both Parties.
      </p>
      <p style={sub}>
        13.3 If any provision of this Agreement is held invalid or unenforceable, the remaining provisions shall continue in
        full force and effect.
      </p>

      <h2 style={sectionTitle}>ANNEXURE A — ASSOCIATE PROFILE</h2>
      <p style={body}>
        (To be completed by the Associate at the time of empanelment — refer to the separate Empanelment Application
        Form and Document Checklist provided along with this Agreement.)
      </p>

      <h2 style={sectionTitle}>ANNEXURE B — PAYOUT / COMMISSION STRUCTURE</h2>
      <div style={{ overflowX: 'auto', marginBottom: 16 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead>
            <tr>
              {['Loan Product', 'Payout (% of disbursed amount)', 'Clawback Period'].map((h) => (
                <th key={h} style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', background: '#f8fafc' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[
              ['Home Loan', '50 to 70 % of Bank or NBFC Payout', '60 days from Disbursement'],
              ['Loan Against Property', '50 to 70 % of Bank or NBFC Payout', '60 days from Disbursement'],
              ['Personal Loan', '50 to 70 % of Bank or NBFC Payout', '60 days from Disbursement'],
              ['Business Loan', '50 to 70 % of Bank or NBFC Payout', '60 days from Disbursement'],
              ['Education Loan with Collateral', '50 to 70 % of Bank or NBFC Payout', '60 days from Disbursement'],
              ['Reverse Mortgage Loan', '50 to 70 % of Bank or NBFC Payout', '60 days from Disbursement'],
            ].map((row) => (
              <tr key={row[0]}>
                {row.map((cell) => (
                  <td key={cell} style={{ border: '1px solid #cbd5e1', padding: '8px', verticalAlign: 'top' }}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p style={sub}>1. The above payout differs if there is any subvention or waivers in Rate or PF, Loan based on institution decision.</p>
      <p style={sub}>2. The above payout may change subject to any changes in payout from Banks / NBFCs and the same will be applicable.</p>
      <p style={sub}>3. If any amount is recovered by the bank for cancellation of cases, non closure of BT cheques, subventions, waivers in Rate / PF, Penalty or for any other reason, the same will be recovered by the company.</p>
      <p style={sub}>4. Banks / NBFCs are also settling the BT cheques against the loan amount if not closed with in 60days, They are recovering the subsequent amount from our payout, the same will be recovered by the company. So please ensure BT cheques are closed in time (within 60 days).</p>
      <p style={sub}>5. All the payouts mentioned above are inclusive of TDS only and the GST will be paid in excess to registered GST vendors.</p>
      <p style={sub}>6. HDFC For cases booked under non-geography location, 1% penalty will be charged which will be recovered in next month’s payout</p>
      <p style={sub}>7. For cases where Balance transfer cheques is not encashed within the defined timeline, payout recovery for those cases will be charged in next month’s payout.</p>

      <h2 style={sectionTitle}>8. Addendum for Change in Product / Introduction of New Product</h2>
      <p style={sub}>
        1. In the event of any change, modification, addition, or introduction of a new loan product/service, the Partner
        / Individual DSA / Connector shall execute a separate Addendum to this Agreement, incorporating the applicable
        terms, conditions, commercial arrangements, payout structure, and other relevant provisions for such
        product/service.
      </p>
      <p style={sub}>
        2. The execution of such Addendum by the Partner / Individual DSA / Connector shall be mandatory for
        continuation of the services and business association under the revised or newly introduced product. The
        Addendum shall form an integral part of this Agreement and shall be binding on all parties upon execution.
      </p>
      <p style={sub}>
        3. No Partner / Individual DSA / Connector shall be entitled to offer, source, process, or continue services for any
        revised or newly introduced product unless the applicable Addendum has been duly executed by the parties
        concerned.
      </p>

      <h2 style={sectionTitle}>IN WITNESS WHEREOF</h2>
      <p style={body}>
        The Parties have executed this Agreement on the date first mentioned above.
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, marginTop: 24 }}>
        <div>
          <p style={{ fontWeight: 700, marginBottom: 20 }}>For DHANSTHAL (Powered by Kadellabs)</p>
          <p style={sub}>Authorised Signatory</p>
          <p style={sub}>Name:</p>
          <p style={sub}>Designation:</p>
          <p style={sub}>Date:</p>
        </div>
        <div>
          <p style={{ fontWeight: 700, marginBottom: 20 }}>For the ASSOCIATE / LOAN CONNECTOR</p>
          <p style={sub}>Authorised Signatory</p>
          <p style={sub}>Name:</p>
          <p style={sub}>Designation:</p>
          <p style={sub}>Date:</p>
        </div>
      </div>
    </div>
  );
}
